export const SETUP_TWO_FACTOR_AUTHENTICATION_STEP = 'setupTwoFactorAuthenticationStep';
export const ENABLE_TWO_FACTOR_AUTHENTICATION_STEP = 'enableTwoFactorAuthenticationStep';
